// ============================================================
// Datei: src/pages/ressorts/KaffimobilMobile.jsx
//
// ÄNDERUNGEN:
// - Unter dem Haupt-Tab "Libellen" wurden 2 Unter-Tabs ergänzt:
//   1. Ressort
//   2. Helferpool
// - Im Tab "Ressort" bleibt die bestehende VolunteerList unverändert
// - Im Tab "Helferpool" wird der bereits vorhandene VolunteerPool angezeigt
// - Rechteckige Register oberhalb des Tab-Inhalts ergänzt
// - Nach erfolgreicher Zuweisung aus dem Helferpool wird reloadVolunteers()
//   aufgerufen, damit die Ressort-Liste aktuell bleibt
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import VolunteerPool from "../../../components/VolunteerPool";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./kaffimobilMobile.css";

const KaffimobilMobile = ({
    volunteers,
    setVolunteers,
    shifts,
    guests,
    activeTab,
    setActiveTab,
    reloadGuests,
    reloadVolunteers,
    setSelectedVolunteer
}) => {
    // ============================================================
    // STATE
    // ============================================================
    const [guestToEdit, setGuestToEdit] = useState(null);
    const [guestToDelete, setGuestToDelete] = useState(null);

    // ------------------------------------------------------------
    // Untertab für den Bereich "Libellen"
    // "ressort" = bestehende Ressort-Helferliste
    // "pool"    = Helferpool
    // ------------------------------------------------------------
    const [helpersSubTab, setHelpersSubTab] = useState("ressort");

    // ============================================================
    // SCHICHTEN FÜR KAFFIMOBIL
    // ============================================================
    const kaffimobil = shifts.filter(
        (s) => s.shiftId >= 121 && s.shiftId <= 128
    );

    // ============================================================
    // HAUPT-TABS
    // ============================================================
    const tabs = [
        { id: "overview", label: "Übersicht" },
        { id: "helpers", label: "Libellen" },
        { id: "shifts", label: "Schichtplan" },
//        { id: "guests", label: "Gästeliste" },
//        { id: "extras", label: "Extrawürscht" }
    ];

    return (
        <>
            <div className="tabs-container">
                <div className="tab-bar">
                    {tabs.map((t) => (
                        <button
                            key={t.id}
                            type="button"
                            className={
                                "tab-button" +
                                (activeTab === t.id ? " tab-button-active" : "")
                            }
                            onClick={() => setActiveTab(t.id)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                <div className="tab-panels">
                    {/* ================= HELPERS / LIBELLEN ================= */}
                    {activeTab === "helpers" && (
                        <>
                            {/* ------------------------------------------------
                                UNTER-TABS FÜR LIBELLEN
                                Rechteckige Register für:
                                1. Ressort
                                2. Helferpool
                               ------------------------------------------------ */}
                            <div className="helpers-subtab-bar">
                                <button
                                    type="button"
                                    className={
                                        "helpers-subtab-button" +
                                        (helpersSubTab === "ressort"
                                            ? " helpers-subtab-button-active"
                                            : "")
                                    }
                                    onClick={() => setHelpersSubTab("ressort")}
                                >
                                    Ressort
                                </button>

                                <button
                                    type="button"
                                    className={
                                        "helpers-subtab-button" +
                                        (helpersSubTab === "pool"
                                            ? " helpers-subtab-button-active"
                                            : "")
                                    }
                                    onClick={() => setHelpersSubTab("pool")}
                                >
                                    Helferpool
                                </button>
                            </div>

                            {/* --------------------------------------------
                               TAB 1 = RESSORT
                               Bestehende VolunteerList bleibt unverändert
                               -------------------------------------------- */}
                            {helpersSubTab === "ressort" && (
                                <VolunteerList
                                    volunteers={volunteers}
                                    setVolunteers={setVolunteers}
                                    onEdit={setSelectedVolunteer}
                                    reloadVolunteers={reloadVolunteers}
                                />
                            )}

                            {/* --------------------------------------------
                               TAB 2 = HELFERPOOL
                               Bereits vorhandene Komponente VolunteerPool
                               -------------------------------------------- */}
                            {helpersSubTab === "pool" && (
                                <VolunteerPool
                                    departmentName="Kaffimobil"
                                    onAssigned={() => {
                                        // Nach erfolgreicher Zuweisung
                                        // die Ressort-Helferliste neu laden
                                        reloadVolunteers();
                                    }}
                                />
                            )}
                        </>
                    )}

                    {/* ================= SHIFTS ================= */}
                    {activeTab === "shifts" && (
                        <>
                            <h3 className="kaffimobil-subheading">Aufbau</h3>
                            <ShiftTable shifts={kaffimobil} />

                            <h3 className="kaffimobil-subheading">Abbau</h3>
                            <ShiftTable shifts={kaffimobil} />
                        </>
                    )}

                    {/* ================= GUESTS ================= */}
                    {activeTab === "guests" && (
                        <>
                            <GuestRegistration refreshGuestList={reloadGuests} />

                            <GuestList
                                guests={guests}
                                refreshGuestList={reloadGuests}
                                onEdit={(g) => setGuestToEdit(g)}
                                onDelete={(g) => setGuestToDelete(g)}
                            />
                        </>
                    )}
                </div>
            </div>

            {/* ================= MODALS ================= */}
            {guestToEdit && (
                <EditGuestModal
                    guest={guestToEdit}
                    onClose={() => setGuestToEdit(null)}
                    onSaved={() => {
                        setGuestToEdit(null);
                        reloadGuests();
                    }}
                />
            )}

            {guestToDelete && (
                <DeleteGuestModal
                    guest={guestToDelete}
                    onClose={() => setGuestToDelete(null)}
                    onDeleted={() => {
                        setGuestToDelete(null);
                        reloadGuests();
                    }}
                />
            )}
        </>
    );
};

export default KaffimobilMobile;